import { useGameStore, CameraMode } from "../core/store/gameStore";
import { LoadingScreen } from "./LoadingScreen";
import AudioButton from "./AudioButton";
import { SideBar } from "./SideBar";
import { OrientationHint } from "./OrientationHint";
import { TouchJoystick } from "../core/input/TouchJoystick";
import { input } from "../core/input/controls";
import { ImportPanel } from "./ImportPanel";

function PavilionHint() {
    const near = useGameStore((state) => state.hexPavilionNear);
    const show = near;
    return (
        <div style={{
            position: 'absolute',
            bottom: '96px',
            left: '50%',
            transform: 'translateX(-50%)',
            pointerEvents: 'none',
            padding: '10px 22px',
            borderRadius: '24px',
            background: 'rgba(18, 22, 26, 0.62)',
            color: '#f2ead8',
            fontFamily: 'system-ui, "PingFang SC", "Microsoft YaHei", sans-serif',
            fontSize: '15px',
            letterSpacing: '1px',
            backdropFilter: 'blur(6px)',
            border: '1px solid rgba(255, 220, 150, 0.35)',
            boxShadow: '0 8px 30px rgba(0,0,0,0.35)',
            opacity: show ? 1 : 0,
            visibility: show ? 'visible' : 'hidden',
            transition: 'opacity 0.5s ease, visibility 0s linear 0.5s',
            whiteSpace: 'nowrap',
        }}>
            六角亭 · 寻青亭 — 石砌基座、重檐攒尖、深瓦飞檐。入内歇息，灯为您点亮
        </div>
    );
}

function DroneHint() {
    const isMobile = useGameStore((state) => state.isMobile);
    const cameraMode = useGameStore((state) => state.cameraMode);
    const isControlEnabled = useGameStore((state) => state.isControlEnabled);
    const show = !isMobile && isControlEnabled && cameraMode === CameraMode.Drone;

    return (
        <div style={{
            position: 'fixed',
            bottom: '14px',
            left: '50%',
            transform: 'translateX(-50%)',
            pointerEvents: 'none',
            padding: '7px 16px',
            borderRadius: '18px',
            background: 'rgba(10, 14, 18, 0.5)',
            color: 'rgba(255,255,255,0.78)',
            fontFamily: 'Cousine, monospace',
            fontSize: '12px',
            letterSpacing: '0.6px',
            backdropFilter: 'blur(4px)',
            border: '1px solid rgba(255,255,255,0.12)',
            whiteSpace: 'nowrap',
            opacity: show ? 1 : 0,
            transition: 'opacity 0.4s ease',
        }}>
            CLICK TO LOCK MOUSE · WASD MOVE · SPACE UP · SHIFT DOWN · R SPRINT · C EXIT
        </div>
    );
}

export function UI() {
    const isMobile = useGameStore((state) => state.isMobile);
    const isControlEnabled = useGameStore((state) => state.isControlEnabled);

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none', // Critical: lets clicks pass through to the 3D canvas
            zIndex: 10 // Ensure UI is above Canvas
        }}>
            <LoadingScreen />
            <OrientationHint />
            <PavilionHint />
            <DroneHint />
            <div style={{
                position: 'absolute',
                top: 0, left: 0, width: '100%', height: '100%',
                pointerEvents: 'none',

                opacity: isControlEnabled ? 1 : 0,
                visibility: isControlEnabled ? 'visible' : 'hidden',
                transition: `opacity 0.5s ease, visibility 0s linear ${isControlEnabled ? '0s' : '0.5s'}`
            }}>
                <AudioButton />
                <SideBar />
                <ImportPanel />

                {isMobile &&
                    <TouchJoystick
                        input={input}
                        actions={{
                            forward: 'MoveForward',
                            backward: 'MoveBackward',
                            left: 'RotateLeft',
                            right: 'RotateRight',
                            run: 'Run'
                        }} />}
            </div>
        </div>
    );
}